import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PlatformUsers from "./PlatformUsers";

function safeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

function normalizePlatformRole(v) {
  const r = safeString(v).trim().toUpperCase();
  if (r === "SUPER_ADMIN" || r === "ADMIN" || r === "SUPPORT") return r;
  return "";
}

export default function PlatformUsersHub() {
  const auth = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const token = safeString(auth?.token).trim();
  const isAuthed = !!token;

  const inPlatformRoute = loc.pathname.startsWith("/platform");
  const platformRole = normalizePlatformRole(auth?.user?.platformRole ?? auth?.platformRole ?? "");
  const hasPlatformAccess = !!platformRole;

  if (!isAuthed) {
    return (
      <div className="ft-page">
        <div className="ft-header">
          <div className="ft-header__text">
            <h1 className="ft-title">Users</h1>
            <p className="ft-subtitle">Please sign in to continue.</p>
          </div>
          <div className="ft-header__actions">
            <button className="ft-btn ft-btn--primary" type="button" onClick={() => nav("/login")}>
              Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!hasPlatformAccess) {
    return (
      <div className="ft-page">
        <div className="ft-header">
          <div className="ft-header__text">
            <h1 className="ft-title">Users</h1>
            <p className="ft-subtitle">Your account does not have Platform access.</p>
          </div>
          <div className="ft-header__actions">
            <button className="ft-btn ft-btn--ghost" type="button" onClick={() => nav("/dashboard")}>
              Go to Store
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!inPlatformRoute) {
    return (
      <div className="ft-page">
        <div className="ft-header">
          <div className="ft-header__text">
            <h1 className="ft-title">Users</h1>
            <p className="ft-subtitle">
              This page must be accessed under <b>/platform</b>.
            </p>
          </div>
          <div className="ft-header__actions">
            <button className="ft-btn ft-btn--primary" type="button" onClick={() => nav("/platform/users")}>
              Go to Platform Users
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <PlatformUsers />;
}